import React, { useState } from 'react'
import { View, StyleSheet } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Text, Icon } from '@components'
import { Theme } from '@theme'

interface SectionTitleProps {
  title: string
  subtitle?: string
  collapsible?: boolean
  children?: React.ReactElement | React.ReactElement[]
  right?: React.ReactElement
}

export const SectionTitle: React.FC<SectionTitleProps> = ({ title, subtitle, collapsible, children, right }) => {
  const theme = useTheme()
  const styles = getStyle(theme)
  const [showContent, setShowContent] = useState(true)

  const toggleContent = () => { setShowContent(content => !content)}
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <View>
          <Text type="bodyBold" color={theme.colors.black} style={styles.title}>
            {title}
          </Text>
          {!!subtitle && <Text type="bodyExtraSmall" color={theme.colors.black}>
            {subtitle}
          </Text>}
        </View>
        {collapsible && <Icon name={showContent? 'arrowDown'  : 'arrowUp'} onPress={toggleContent}/>}
        {!collapsible && right}
      </View>
      {showContent && children}
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      marginTop: theme.spacing.xl,
    },
    content: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottomColor: theme.colors.primary,
      borderBottomWidth: 1,
      marginBottom: theme.spacing.lg,
      paddingBottom: theme.spacing.sm
    },
    title: {
    }
  }) 